import { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import DocumentMeta from "react-document-meta";
import { withRouter, Link } from "react-router-dom";
import RevSlider, { Slide, Caption } from "react-rev-slider";
import Slider from "react-slick";
import { Player } from "video-react";
import parse from "html-react-parser";
import pmPng from "../../../../assets/images/pm.png";
import arrow from "../../../../assets/images/arrow.png";
import bg2Img from "../../../../assets/images/bg2.jpg";
import videoHash from "../../../../assets/images/videoHash.png";
import videoHash2 from "../../../../assets/images/videoHash2.png";
import ReactReadMoreReadLess from "react-read-more-read-less";
import ReadMore from "../../../common/ReadMore";
import { ExpandMore, ExpandLess, DoubleArrowRounded } from "@material-ui/icons";

import "./style.css";
import "./styles.scss";

const StartupNMPVideo = (props) => {
  // //
  const [isPlay, setIsPlay] = useState(false);
  const [clickedplaybtn, setClickplaybtn] = useState(false);
  const [text, setText] = useState();
  const videocover = useRef(null);
  useEffect(() => {
    setText(props.data && props.data[0].BannerSubtitle);
    // //
  }, [props.data]);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const config = {
    delay: 9000,
    startwidth: 1170,
    startheight: 500,
    hideThumbs: 10,
    fullWidth: "on",
    forceFullWidth: "on",
  };
  const meta={
    title: 'MAARG',
    description: '',
    canonical: 'https://maarg.startupindia.gov.in/',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'Mentorship,startupindia,startup, mentor, Mentor , Startup'
        }
    }
};
  const data = [
    {
      name: "Mentor A",
      image: "https://sensez9.tech/MNP/assets/images/tm-1.jpg",
    },
    // ,
    // {
    //     name:"Mentor A",
    //     image:"https://sensez9.tech/MNP/assets/images/tm-1.jpg"
    // }
  ];

  const onPlayerPlay = () => {
    setIsPlay(true);
  };

  return (
    <DocumentMeta {...meta}>
      {/* <Slider {...settings}>  */}
      <div
        className="nmp-video-bg"
        style={{
          background: { bg2Img },
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        {/* "background: url(assets/images/bg2.jpg);background-position: center;background-size:cover ;" */}
        <div className="w-100 pt-50 pb-50 position-relative container">
          <Slider {...settings}>
            {/* <div className="container"> */}

            {data.map((value, index) => {
              return (
                <div className="div-row">
                  <div className="float-child1 slideInLeft">
                    <div className="content" style={{ paddingLeft: "0px" }}>
                      <h2 className="mb-0 homepageFirstHeader">
                        {/* Startup India <br></br> National Mentorship Platform */}
                        {/* {props.data
                          ? parse(props.data[0].BannerTitle)
                          : parse("MAARG Portal")} */}
                          MAARG Portal
                      </h2>
                      <br></br>
                      <p className="homepageFirstDescription">
                        {/* <div className="read-more-container">
      <h2> */}
                        <div className="mr20 homepageFirstDescription" style={{ textAlign: "justify" }}>
                          {text ? (
                            <ReadMore>{text}</ReadMore>
                          ) : (
                            "The Startup India National Mentorship Platform is a one-stop platform to facilitate startups across sectors, functions, stages, geographies, and backgrounds to receive mentorship from experts. Startups can leverage the platform to connect"
                          )}
                        </div>
                        {/* </h2>
    </div> */}
                        {/* <ReactReadMoreReadLess
                          charLimit={150}
                          readMoreText={
                            <DoubleArrowRounded style={{ fontSize: "30px" }} />
                          }
                          readLessText={
                            <DoubleArrowRounded style={{ fontSize: "30px" }} />
                          }
                          readMoreClassName="read-more-less--more"
                          readLessClassName="read-more-less--less"
                        >
                          { */}
                        {/* "The Startup India National Mentorship Platform is a one-stop platform to facilitate startups across sectors, functions, stages, geographies, and backgrounds to receive mentorship from experts. Startups can leverage the platform to connect" */}
                        {/* }
                        </ReactReadMoreReadLess> */}
                      </p>
                      {/* <img style={{marginLeft:"90%",marginTop:"15px"}}src={arrow}/> */}
                    </div>
                  </div>

                  <div
                    className="float-child2 slideInRight"
                    style={{ marginTop: "15px" }}
                  >
                    <a className="wplightbox" style={{ cursor: "pointer" }}>
                      <div
                        // ref={lighthousebtn}
                        className={
                          clickedplaybtn === true
                            ? "videoContainerNew"
                            : "lightboxContainer videoContainerNew"
                        }
                        // style={{
                        //   pointerEvents: "none",
                        // }}
                        // onClick={() => {
                        //   setClickplaybtn(true);
                        // }}
                        //   className="
                        // videoContainerNew"
                      >
                        {/* <div className="pm-img">
                          <div
                            className="mckp-img text-center tilt w-100"
                            data-max_tilt="10"
                            data-perspective="1000"
                            data-scale="1"
                            data-speed="700"
                          >
                            <img className="img-fluid" src={pmPng} alt="" />
                          </div>
                        </div> */}

                        <div className="yt-wrapper">
                          <div className="yt-inner">
                            {/* {!isPlay && (
                              <div className="video-cover">
                                <img
                                  className=""
                                  src={
                                    "https://uat.wastetowealth.gov.in/s3fs/2021-12/Screenshot%20from%202021-10-01%2019-10-49.png"
                                  }
                                  alt=""
                                />
                              </div>
                            )} */}
                            {/* <Player
                              className="videoPlayer"
                              playsInline
                              poster={
                                "https://uat.wastetowealth.gov.in/s3fs/2021-12/Screenshot%20from%202021-10-01%2019-10-49.png"
                              }
                              src={
                                "https://www.wastetowealth.gov.in/s3fs/s3fs-public/video-thumbnails/2021-10/17ca0030-1878-42ba-a8a3-962efab365f2.mp4"
                              }
                              onPlay={onPlayerPlay}
                              fullscreen={true}
                              // onPlay={true}
                            /> */}

                                <div
                                ref={videocover}
                                className="video-cover"
                                style={{
                                  width: "569px",
                                  height: "320px",
                                  pointerEvents: "none",
                                }}
                                // onClick={() => {
                                //   videocover.current.style.display = "none";
                                // }}
                              >
                                <img
                                  className=""
                                  src={videoHash2}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    zIndex: "100",
                                  }}
                                />
                              </div>
                          
                            {/* <iframe
                              width="853"
                              height="320"
                              src={
                                "https://www.wastetowealth.gov.in/s3fs/s3fs-public/video-thumbnails/2021-10/17ca0030-1878-42ba-a8a3-962efab365f2.mp4"
                              }
                              frameBorder="0"
                              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                              title="Embedded youtube"

                              // onClick={() => {
                              //   videocover.current.style.display = "none";
                              // }}
                            /> */}
                            <video
                              controls
                              onPlay={() => {
                                videocover.current.style.display = "none";
                                setClickplaybtn(true);
                              }}
                              width="853"
                              height="320"
                              style={{ zIndex: "10" }}
                              src={
                                "https://maarg-api.startupindia.gov.in/mentorship-app/v1/document/bucket/ii-nmp-maarg-static-files/s3fs/s3fs-public/2022-07/MAARG_Mentorship_30.06.22.mp4?VersionId=nLD_FFToQZdYtm7QuQGCE6eyhv_GUlOl"
                              }
                              frameBorder="0"
                              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                              onEnded={() => {videocover.current.style.display = "block"}}
                            />
                            {/* <source src="mov_bbb.mp4" type="video/mp4">
  <source src="mov_bbb.ogg" type="video/ogg">
  Your browser does not support HTML5 video.
</video> */}
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              );
            })}
            {/* <div className="row text-center"><a href="#"><img src={arrow} alt="" border="0" /></a></div> */}

            {/* </div> */}
          </Slider>
        </div>
      </div>
      {/* </Slider> */}
    </DocumentMeta>
  );
};

const mapStateToProps = (state) => {
  return {};
};
export default StartupNMPVideo;
